// src/components/Navbar.js - FIXED: Perfect Button Click Behavior!
import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import { useAuth } from '../context/AuthContext';
import { useProfile } from '../context/ProfileContext';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const { getCartItemCount } = useCart();
  const { user, logout } = useAuth();
  const { profile } = useProfile();
  
  const cartItemCount = getCartItemCount();

  const navLinks = [
    { path: '/', label: 'Home', icon: '🏠' },
    { path: '/menu', label: 'Menu', icon: '🍽️' },
    { path: '/contact', label: 'Contact', icon: '📞' },
    { path: '/cart', label: 'Cart', icon: '🛒', badge: cartItemCount },
    { path: '/profile', label: 'Profile', icon: '👤' },
    { path: '/about', label: 'About', icon: 'ℹ️' }, // Added About link
    { path: '/orders', label: 'Orders', icon: '📦' }, // Added Orders link
    { path: '/reviews', label: 'Reviews', icon: '⭐' } // Added Reviews link
  ];

  return (
    <nav style={{
      background: 'linear-gradient(135deg, #008751, #fb923c)',
      padding: '1rem 0',
      boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
      position: 'sticky',
      top: 0,
      zIndex: 1000,
      backdropFilter: 'blur(10px)'
    }}>
      <div style={{
        maxWidth: '1200px',
        margin: '0 auto',
        padding: '0 2rem',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
      }}>
        {/* Logo - FIXED: No more shaking */}
        <Link 
          to="/" 
          style={{
            fontSize: '2rem',
            fontWeight: '900',
            color: 'white',
            textDecoration: 'none',
            textShadow: '2px 2px 4px rgba(0,0,0,0.3)',
            transition: 'all 0.3s ease'
          }}
          onMouseOver={(e) => {
            e.target.style.transform = 'translateY(-2px)'; // FIXED: Only vertical movement
            e.target.style.textShadow = '3px 3px 6px rgba(0,0,0,0.4)';
          }}
          onMouseOut={(e) => {
            e.target.style.transform = 'translateY(0)';
            e.target.style.textShadow = '2px 2px 4px rgba(0,0,0,0.3)';
          }}
        >
          {/* FIXED: Logo text can't interfere with clicks */}
          <span style={{ pointerEvents: 'none' }}>🍽️ TiwaTinwa </span>
        </Link>

        {/* Desktop Navigation - FIXED */}
        <div style={{ display: 'flex', gap: '2rem', alignItems: 'center' }}>
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              style={{
                color: 'white',
                textDecoration: 'none',
                fontWeight: '700',
                fontSize: '1.1rem',
                padding: '0.8rem 1.5rem',
                borderRadius: '25px',
                transition: 'all 0.3s ease',
                background: location.pathname === link.path 
                  ? 'rgba(255,255,255,0.2)' 
                  : 'transparent',
                border: location.pathname === link.path 
                  ? '2px solid rgba(255,255,255,0.3)' 
                  : '2px solid transparent',
                position: 'relative',
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem'
              }}
            >
              {/* FIXED: Nav text can't interfere with clicks */}
              <span style={{ pointerEvents: 'none' }}>{link.icon}</span>
              <span style={{ pointerEvents: 'none' }}>{link.label}</span>
              
              {/* Cart Badge - FIXED */}
              {link.badge > 0 && (
                <span style={{
                  background: '#ff4757',
                  color: 'white',
                  borderRadius: '50%',
                  padding: '0.2rem 0.5rem',
                  fontSize: '0.8rem',
                  fontWeight: '900',
                  minWidth: '1.5rem',
                  height: '1.5rem',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  position: 'absolute',
                  top: '-5px',
                  right: '-5px',
                  animation: 'pulse 2s infinite',
                  pointerEvents: 'none' // FIXED: Badge can't interfere
                }}>
                  {link.badge}
                </span>
              )}
            </Link>
          ))}

          {/* Auth Button - FIXED */}
          {user ? (
            <button 
              onClick={logout} 
              style={{
                background: 'rgba(255,255,255,0.2)',
                color: 'white',
                border: 'none',
                borderRadius: '25px',
                padding: '0.8rem 1.5rem',
                fontWeight: '700',
                fontSize: '1.1rem',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem',
                position: 'relative'
              }}
              onMouseOver={(e) => {
                e.target.style.background = 'rgba(255,255,255,0.3)';
                e.target.style.transform = 'translateY(-2px)'; // FIXED: No scaling
              }}
              onMouseOut={(e) => {
                e.target.style.background = 'rgba(255,255,255,0.2)';
                e.target.style.transform = 'translateY(0)';
              }}
            >
              <span style={{ pointerEvents: 'none' }}>🚪 Logout</span>
            </button>
          ) : (
            <Link 
              to="/auth" 
              style={{
                background: 'rgba(255,255,255,0.2)',
                color: 'white',
                textDecoration: 'none',
                borderRadius: '25px',
                padding: '0.8rem 1.5rem',
                fontWeight: '700',
                fontSize: '1.1rem',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem',
                position: 'relative'
              }}
              onMouseOver={(e) => {
                e.target.style.background = 'rgba(255,255,255,0.3)';
                e.target.style.transform = 'translateY(-2px)'; // FIXED: No scaling
              }}
              onMouseOut={(e) => {
                e.target.style.background = 'rgba(255,255,255,0.2)';
                e.target.style.transform = 'translateY(0)';
              }}
            >
              <span style={{ pointerEvents: 'none' }}>🔑 Login</span>
            </Link>
          )}
        </div>

        {/* Mobile Menu Button - FIXED */}
        <button
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          style={{
            display: 'none',
            background: 'rgba(255,255,255,0.2)',
            border: 'none',
            color: 'white',
            fontSize: '1.5rem',
            padding: '0.5rem',
            borderRadius: '10px',
            cursor: 'pointer',
            transition: 'all 0.3s ease'
          }}
          onMouseOver={(e) => {
            e.target.style.background = 'rgba(255,255,255,0.3)';
            e.target.style.transform = 'translateY(-2px)'; // FIXED: No scaling
          }}
          onMouseOut={(e) => {
            e.target.style.background = 'rgba(255,255,255,0.2)';
            e.target.style.transform = 'translateY(0)';
          }}
        >
          {/* FIXED: Button text can't interfere */}
          <span style={{ pointerEvents: 'none' }}>
            {isMenuOpen ? '✕' : '☰'}
          </span>
        </button>
      </div>

      {/* Mobile Menu - FIXED */}
      {isMenuOpen && (
        <div style={{
          background: 'rgba(0, 135, 81, 0.95)',
          padding: '1rem 2rem',
          backdropFilter: 'blur(10px)'
        }}>
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              onClick={() => setIsMenuOpen(false)}
              style={{
                display: 'block',
                color: 'white',
                textDecoration: 'none',
                fontWeight: '700',
                fontSize: '1.1rem',
                padding: '1rem 0',
                borderBottom: '1px solid rgba(255,255,255,0.1)',
                position: 'relative',
                transition: 'all 0.3s ease'
              }}
              onMouseOver={(e) => {
                e.target.style.background = 'rgba(255,255,255,0.1)';
                e.target.style.transform = 'translateX(10px)'; // FIXED: Smooth slide effect
              }}
              onMouseOut={(e) => {
                e.target.style.background = 'transparent';
                e.target.style.transform = 'translateX(0)';
              }}
            >
              {/* FIXED: Mobile menu text can't interfere */}
              <span style={{ marginRight: '0.5rem', pointerEvents: 'none' }}>
                {link.icon}
              </span>
              <span style={{ pointerEvents: 'none' }}>
                {link.label}
              </span>
              {link.badge > 0 && (
                <span style={{
                  background: '#ff4757',
                  color: 'white',
                  borderRadius: '50%',
                  padding: '0.2rem 0.5rem',
                  fontSize: '0.8rem',
                  fontWeight: '900',
                  marginLeft: '0.5rem',
                  pointerEvents: 'none' // FIXED: Badge can't interfere
                }}>
                  {link.badge}
                </span>
              )}
            </Link>
          ))}
        </div>
      )}

      {/* Profile Avatar - FIXED: Integrated into Navbar */}
      <div className="navbar-profile" style={{
        position: 'absolute',
        top: '1rem',
        right: '2rem',
        display: 'flex',
        alignItems: 'center',
        gap: '0.5rem',
        pointerEvents: 'none'
      }}>
        <img 
          src={profile.avatar || '/default-avatar.png'}
          alt="Avatar"
          className="navbar-profile-avatar"
          style={{
            width: 36,
            height: 36,
            borderRadius: '50%',
            objectFit: 'cover',
            border: '2px solid #008751'
          }}
        />
        <span className="navbar-profile-name" style={{
          color: 'white',
          fontWeight: '700',
          fontSize: '1rem',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          maxWidth: '150px',
          display: 'block',
          pointerEvents: 'none'
        }}>
          {user ? `Welcome, ${user.name}` : 'Welcome, Guest'}
        </span>
      </div>

      <style>{`
        @keyframes pulse {
          0%, 100% { transform: scale(1); }
          50% { transform: scale(1.1); }
        }
        
        @media (max-width: 768px) {
          nav > div > div:nth-child(2) {
            display: none !important;
          }
          nav > div > button {
            display: block !important;
          }
        }
      `}</style>
    </nav>
  );
};

export default Navbar;